import React from 'react';

import { isEqual, noop } from 'lodash';
import { shape, bool, func } from 'prop-types';
import { connect } from 'react-redux';

import DesktopSideNav from 'components/Common/LayoutV2/SideNav/DesktopSideNav/DesktopSideNav';
import MobileSideNav from 'components/Common/LayoutV2/SideNav/MobileSideNav';
import withUserType from 'containers/withUserType';

@withUserType
@connect(
  ({ user: { moduleAccess, userMode } }) => ({
    moduleAccess,
    userMode,
  }),
  null,
)
export default class SideNav extends React.Component {
  shouldComponentUpdate(nextProps, nextStates) {
    return !isEqual(nextProps, this.props) || !isEqual(nextStates, this.state);
  }

  render() {
    const {
      user,
      userMode,
      moduleAccess,
      isDesktop,
      appbarOpen,
      toggleAppbar = () => null,
      push = () => null,
      responsive,
      ...restProps
    } = this.props;

    if (!moduleAccess) return null;
    if (!isDesktop && responsive)
      return (
        <MobileSideNav
          {...{
            push,
            appbarOpen,
            toggleAppbar,
            ...restProps,
          }}
        />
      );
    return <DesktopSideNav {...restProps} />;
  }
}

SideNav.propTypes = {
  moduleAccess: shape({}),
  user: shape({}),
  userMode: shape({}),
  isDesktop: bool,
  appbarOpen: bool,
  toggleAppbar: func,
  push: func,
  responsive: bool,
  isOnboarding: bool,
};

SideNav.defaultProps = {
  moduleAccess: undefined,
  user: null,
  userMode: null,
  isDesktop: true,
  appbarOpen: false,
  toggleAppbar: noop,
  push: noop,
  responsive: false,
  isOnboarding: false,
};
